import { useState, useEffect } from "react";
var gameContainer = null;
// Hook
export function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  // const [windowSize, setWindowSize] = useState({
  //   width: undefined,
  //   height: undefined,
  // });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if(!gameContainer) {
        gameContainer = document.getElementById('game-root-page-obj');
      }

      if(gameContainer) {
	      const scale = Math.min(window.innerWidth / 1920, window.innerHeight / 1080);
        gameContainer.style.transform = 'scale(' + scale + ') translate(-50%, -50%)';
      }
      // Set window width/height to state
      // setWindowSize({
      //   width: window.innerWidth,
      //   height: window.innerHeight,
      // });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return 0;
}
